



































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { GetHospitals, CreatePatient } from "@/request/edr";
@Component({})
export default class EdrAddPatient extends Vue {
  @Prop()
  private ifShow: any;
  @Prop()
  private patient: any;
  @Prop()
  private project: any;
  @Prop()
  private groupId: any;
  private hospitals: any[] = [];
  private get visible() {
    return this.ifShow;
  }
  private set visible(val) {
    this.$emit("update:ifShow", val);
  }
  private patientChange() {
    this.$emit("update:patient", this.patient);
  }
  /**
   * @description 获得所有可选学校的列表
   */
  private fetchSchools() {
    const params: any = {
      params: {
        project_id: this.$route.query.project_id
      }
    };
    GetHospitals(this, params).then((data: any) => {
      this.hospitals = data;
    });
  }
  /**
   * @description 取消
   */
  private cancel() {
    this.$emit("update:patient", {});
    this.$emit("update:ifShow", false);
  }
  /**
   * @description 保存
   */
  private save() {
    if (!this.patient["姓名"]) {
      this.$message.warning("姓名必须填写");
      return;
    }
    if (!this.patient["性别"]) {
      this.$message.warning("性别必须填写");
      return;
    }
    if (!this.patient["出生日期"]) {
      this.$message.warning("出生日期必须填写");
      return;
    }
    const birthdayRep: RegExp = /\d{4}-[0-1]\d-\d{2}/gi;
    if (!birthdayRep.test(this.patient["出生日期"])) {
      this.$message.warning("出生日期格式不对，请重新输入");
      return;
    }
    if (!this.patient["认证方式"]) {
      this.$message.warning("认证方式必须填写");
      return;
    }
    if (!this.patient["身份证号"]) {
      this.$message.warning("认证号码必须填写");
      return;
    }
    if (!this.patient["hospital_id"]) {
      this.$message.warning("所属机构必须填写");
      return;
    }
    this.patient.group_id = this.groupId;
    this.patient.project_id = this.project.project_id;
    CreatePatient(this, this.patient).then((data: any) => {
      this.$emit("change");
      this.$emit("update:ifShow", false);
    });
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.fetchSchools();
  }
}
